module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico-address-e47ef633921fc6b121424f6d72081c48.svg";